
export const translations = {
  en: {
    nav: {
      home: "Home",
      shop: "Shop",
      journal: "Journal",
      news: "News",
      about: "Our Story",
      login: "Login / Register",
      account: "My Account"
    },
    hero: {
      badge: "Pure Nature, Pure Love",
      title1: "Nutrition",
      title2: "Back to Nature",
      desc: "We adhere to minimalist purity and radical transparency. Providing pets with higher quality, scientifically validated nutritional solutions.",
      explore: "Explore Collection",
      philosophy: "Our Philosophy"
    },
    features: {
      minimalist: "Minimalist Purity",
      minimalist_desc: "We embrace 'Less is More'. Minimal processing to retain nutritional vitality.",
      transparency: "Radical Transparency",
      transparency_desc: "No hidden ingredients. We promise complete transparency in sourcing.",
      science: "Scientific Validation",
      science_desc: "Respecting nature while incorporating rigorous science for safety."
    },
    home: {
      arrivals: "Newest Arrivals",
      arrivals_desc: "The latest additions to our curated nutrition line.",
      view_all: "View Full Collection",
      journal_title: "The Natuvía Journal"
    },
    footer: {
      desc: "Dedicated to providing comprehensive solutions for pet food and supplies based on high-quality, natural ingredients.",
      shop: "Shop",
      support: "Support",
      newsletter: "Newsletter",
      newsletter_desc: "Join our community for pet care tips and exclusive offers.",
      subscribe: "Subscribe"
    },
    cart: {
      title: "Your Cart",
      empty: "Your pantry is empty",
      empty_desc: "Start adding some healthy treats for your pet!",
      start_shopping: "Start Shopping",
      checkout: "Confirm Order",
      login_checkout: "Login to Checkout",
      total: "Total Amount"
    },
    account: {
      title: "Member Center",
      welcome_back: "Welcome back to Natuvía family",
      logout: "Logout",
      tabs: {
        pets: "My Pets",
        orders: "Orders",
        profile: "Settings"
      },
      auth: {
        login_tab: "Login",
        register_tab: "Register",
        full_name: "Full Name",
        email: "Email Address",
        password: "Password",
        confirm_password: "Confirm Password",
        forgot_password: "Forgot Password? Contact Support.",
        register_terms: "By registering, you agree to our Terms of Service.",
        login_btn: "Login Now",
        register_btn: "Join Now"
      },
      pets: {
        family_title: "Pet Family",
        unsaved_changes: "Unsaved Changes",
        health_tracking: "Health Tracking Active",
        human_age: "Human Age",
        feeding: "Daily Feeding",
        birthday: "Birthday",
        weight: "Weight (kg)",
        birthday_countdown: "Birthday in {days} Days",
        save_btn: "Save Profile",
        member_since: "Member Since",
        zodiac_placeholder: "Team Member"
      },
      orders: {
        title: "Order History",
        empty: "No orders found.",
        number: "Order #",
        reorder: "Reorder",
        total: "Total"
      },
      profile: {
        title: "Basic Profile",
        phone: "Phone Number",
        birthday: "Your Birthday",
        address: "Shipping Address",
        save_success: "Profile updated successfully!",
        save_failed: "Update failed: ",
        unsaved_warning: "You have unsaved changes. Leaving now will lose them."
      }
    },
    contact: {
      title: "Contact Us",
      subtitle: "We'd love to hear from you.",
      get_in_touch: "Get in Touch",
      desc: "Have a question about our ingredients? Need help with an order? Our team is here to help you and your pets live their best lives.",
      email_us: "Email Us",
      reply_time: "We usually reply within 24 hours.",
      offices: "Our Offices",
      uk_office: "UK Office",
      hk_office: "HK Office",
      form: {
        name: "Name",
        email: "Email",
        message: "Message",
        name_placeholder: "Your name",
        email_placeholder: "your@email.com",
        message_placeholder: "How can we help?",
        submit: "Send Message",
        sending: "Sending...",
        success_title: "Message Sent!",
        success_desc: "Thank you for reaching out. We will get back to you shortly.",
        another: "Send another message",
        error: "Submission failed. Please try again."
      }
    }
  },
  zh: {
    nav: {
      home: "首頁",
      shop: "商店",
      journal: "日誌",
      news: "最新消息",
      about: "品牌故事",
      login: "登入 / 註冊",
      account: "會員中心"
    },
    hero: {
      badge: "純粹自然，純粹愛",
      title1: "營養",
      title2: "回歸自然",
      desc: "我們堅持極簡純粹與極致透明。為寵物提供高品質、經科學驗證的營養解決方案。",
      explore: "探索系列",
      philosophy: "品牌理念"
    },
    features: {
      minimalist: "極簡純粹",
      minimalist_desc: "我們擁抱「少即是多」。減少過度加工，保留食材最初的營養活力。",
      transparency: "極致透明",
      transparency_desc: "拒絕隱藏成分。我們承諾從來源到生產完全透明。",
      science: "科學驗證",
      science_desc: "尊重天性，同時融入嚴謹科學確保食安與健康。"
    },
    home: {
      arrivals: "新品上市",
      arrivals_desc: "為您的愛寵精心挑選的最新營養系列。",
      view_all: "查看完整系列",
      journal_title: "Natuvía 生活誌"
    },
    footer: {
      desc: "致力於基於優質、天然成分，為寵物食品和用品提供全方位的解決方案。",
      shop: "產品分類",
      support: "顧客支援",
      newsletter: "訂閱通訊",
      newsletter_desc: "加入我們的社區，獲取寵物護理建議和獨家優惠。",
      subscribe: "立即訂閱"
    },
    cart: {
      title: "您的購物籃",
      empty: "您的購物籃是空的",
      empty_desc: "開始為您的寵物挑選健康的餐點吧！",
      start_shopping: "開始購物",
      checkout: "確認訂單",
      login_checkout: "請先登入以結帳",
      total: "結帳總額"
    },
    account: {
      title: "會員中心",
      welcome_back: "歡迎回到 Natuvía 大家庭",
      logout: "登出帳號",
      tabs: {
        pets: "我的寵物",
        orders: "訂單紀錄",
        profile: "個人設定"
      },
      auth: {
        login_tab: "立即登入",
        register_tab: "註冊帳號",
        full_name: "真實姓名",
        email: "電子郵件",
        password: "登入密碼",
        confirm_password: "確認密碼",
        forgot_password: "忘記密碼？請聯繫客服。",
        register_terms: "註冊即代表您同意我們的服務條款。",
        login_btn: "立即登入",
        register_btn: "立即註冊"
      },
      pets: {
        family_title: "寵物家人",
        unsaved_changes: "資料尚未儲存",
        health_tracking: "健康追蹤已啟用",
        human_age: "人類換算年齡",
        feeding: "建議食量",
        birthday: "生日日期",
        weight: "體重 (kg)",
        birthday_countdown: "生日倒數 {days} 天",
        save_btn: "儲存個人檔案",
        member_since: "加入日期",
        zodiac_placeholder: "小隊員"
      },
      orders: {
        title: "訂單紀錄",
        empty: "目前尚無訂單紀錄。",
        number: "訂單編號",
        reorder: "再次購買",
        total: "總金額"
      },
      profile: {
        title: "會員基本資料",
        phone: "聯絡電話",
        birthday: "出生日期",
        address: "完整收貨地址",
        save_success: "會員資料已儲存！",
        save_failed: "儲存失敗：",
        unsaved_warning: "您還有修改過的資料尚未儲存，如果現在離開，變更將會遺失。"
      }
    },
    contact: {
      title: "聯絡我們",
      subtitle: "我們很樂意聽取您的建議與回饋。",
      get_in_touch: "保持聯繫",
      desc: "對成分有疑問？需要訂單協助？我們的團隊隨時在此為您與您的愛寵提供最優質的生活支援。",
      email_us: "電子郵件",
      reply_time: "我們通常會在 24 小時內回覆。",
      offices: "辦公地點",
      uk_office: "英國辦公室",
      hk_office: "香港辦公室",
      form: {
        name: "您的姓名",
        email: "電子郵件",
        message: "留言內容",
        name_placeholder: "請輸入姓名",
        email_placeholder: "your@email.com",
        message_placeholder: "我們能如何協助您？",
        submit: "發送訊息",
        sending: "發送中...",
        success_title: "訊息已成功發送！",
        success_desc: "感謝您的聯絡。我們將會盡快回覆您。",
        another: "再發送一則訊息",
        error: "發送失敗，請稍後再試。"
      }
    }
  }
};
